// 根据域名自动选择 Logto 配置
const getLogtoConfig = () => {
  // 优先使用环境变量
  if (process.env.LOGTO_ENDPOINT && process.env.LOGTO_APP_ID && process.env.LOGTO_RESOURCE) {
    return {
      endpoint: process.env.LOGTO_ENDPOINT,
      appId: process.env.LOGTO_APP_ID,
      resources: [process.env.LOGTO_RESOURCE],
    };
  }

  // 根据域名自动选择
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // 本地开发 → 使用测试环境
    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.endsWith('.local')
    ) {
      return {
        endpoint: 'https://auth.sector0x.xyz/',
        appId: 'a7zl53ap8ok0cdl99x3rn',
        resources: ['https://hasura.api'],
      };
    }

    // 生产环境域名
    if (hostname === 'dashboard.sector0x.com') {
      return {
        endpoint: 'https://auth.sector0x.com/',
        appId: '1mc91fqmee70fr9ynldyq',
        resources: ['https://hasura.api'],
      };
    }

    // 测试环境域名
    if (hostname === 'test-dashboard.sector0x.com') {
      return {
        endpoint: 'https://auth.sector0x.xyz/',
        appId: 'a7zl53ap8ok0cdl99x3rn',
        resources: ['https://hasura.api'],
      };
    }
  }

  // 默认生产环境
  return {
    endpoint: 'https://auth.sector0x.com/',
    appId: '1mc91fqmee70fr9ynldyq',
    resources: ['https://hasura.api'],
  };
};

const baseConfig = getLogtoConfig();

export const logtoConfig = {
  endpoint: baseConfig.endpoint,
  appId: baseConfig.appId,
  resources: baseConfig.resources,
  redirectUri:
    typeof window !== 'undefined'
      ? `${window.location.origin}/callback`
      : 'http://localhost:8000/callback',
  postLogoutRedirectUri:
    typeof window !== 'undefined'
      ? `${window.location.origin}/user/login`
      : 'http://localhost:8000/user/login',
};
